import { useMemo } from 'react';
import { ColDef, FirstDataRenderedEvent, GridReadyEvent, ICellRendererParams, IHeaderParams, ValueGetterParams } from 'ag-grid-community'
import { AgGridReact } from 'ag-grid-react'
import { Glyphicon, OverlayTrigger, Popover } from 'react-bootstrap'
import { ICenterNotification } from '@nkr/models/index'
import { ItemActions } from './item-actions';
import { Utility } from '@nkr/services/utility';
import SortableHeaderComponent from '../list/common/sortable-header'
import ReactHtmlParser from 'react-html-parser';
import OverlayMenuButton, { IMenuItem } from '@nkr/components/overlay-menu-button';

interface IProps {
    data: ICenterNotification[],
    onGridReady: (e: GridReadyEvent) => void,
    onAction: (action: ItemActions, id: number) => void
}

const Grid = (props: IProps) => {
    const onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    };

    const columns: ColDef[] = [
        {
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>R#</SortableHeaderComponent>,
            headerName: 'Center',
            field: 'id',
            width: 90,
            valueGetter: (params: ValueGetterParams)=> params.node.rowIndex + 1
        },

        {
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Center</SortableHeaderComponent>,
            headerName: 'Center',
            field: 'centerAlias',
            comparator: Utility.nameComparator,
            width: 130,
        },

        {
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Description</SortableHeaderComponent>,
            headerName: 'Description',
            field: 'description',
            width: 320,
        },

        {
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Contents</SortableHeaderComponent>,
            headerName: 'Contents',
            field: 'notificationText',
            width: 100,
            cellRendererFramework: (params: ICellRendererParams) => {
                let overlay = <Popover>{ReactHtmlParser(params.data.notificationText)}</Popover>;

                return (
                    <div>
                        <OverlayTrigger trigger={['hover', 'focus']} placement='bottom' overlay={overlay}>
                            <div>view...</div>
                        </OverlayTrigger>
                    </div>
                );
            }
        },

        {
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Enabled</SortableHeaderComponent>,
            headerName: 'Enabled',
            field: 'isEnabled',
            width: 70,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },

        {
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Read</SortableHeaderComponent>,
            headerName: 'Was Read',
            field: 'isRead',
            width: 70,
            cellRendererFramework: (props: ICellRendererParams) => props.value ? <Glyphicon glyph='ok' /> : null
        },

        {
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Read<br />Date/Time</SortableHeaderComponent>,
            headerName: 'Read Date/Time',
            field: 'readDateTime',
            width: 150,
            sortable: true,
            comparator: Utility.dateComparator
        },

        {
            headerComponentFramework: (params: IHeaderParams) => <SortableHeaderComponent {...params}>Read By</SortableHeaderComponent>,
            headerName: 'Ready By',
            field: 'readByUser',
            width: 150,
        },

        {
            headerName: '',
            field: 'id',
            width: 75,
            cellClass: 'action-menu',
            sortable: false,
            cellRendererFramework: (params: ICellRendererParams) => {                
                let menu: IMenuItem[] = [];

                if(!params.data.isRead) 
                    menu.push(
                        {
                            id: params.value,
                            action: 1,
                            include: true,
                            selectable: true,
                            element: <>Edit</>
                        }
                    );

                if(!params.data.isRead) 
                    menu.push(
                        {
                            id: params.value,
                            action: 2,
                            include: true,
                            selectable: true,
                            element: <>Delete</>
                        }
                    );
              
                menu.push(
                    {
                        id: params.value,
                        action: 3,
                        include: true,
                        selectable: true,
                        element: <>Clone</>
                    }
                );
                                
                return <OverlayMenuButton
                    menu={menu}
                    bsStyle='primary'
                    bsSize='xs'
                    title='Actions'
                    listItemStyle={{ padding: '2px 10px', fontSize: 14 }}
                    includeCaret={true}                    
                    onSelect={(id, action) => props.onAction(action, id)}
                />            
            }
        }
    ];

    const columnDefs = useMemo(() => columns, []);
    const rowData = useMemo(() => props.data, [props.data]);

    return (
        <AgGridReact
            columnDefs={columnDefs}
            defaultColDef={{
                cellClass: 'notification-list-cell',
                headerClass: 'notification-list-header',
                sortable: true
            }}
            rowData={rowData}
            headerHeight={45}
            rowHeight={28}
            suppressRowClickSelection={false}
            suppressCellSelection={true}
            suppressContextMenu={true}
            noRowsOverlayComponentFramework={() => <div></div>}
            onGridReady={props.onGridReady}
            onFirstDataRendered={onFirstDataRendered}
        />
    );
}

export default Grid;